<app-page-breadcrumb [pageTitle]="pageTitle"></app-page-breadcrumb>

<div class="grid grid-cols-1 gap-6">
  <app-component-card [title]="pageTitle" desc="Complete los datos de la razón de descalificación">

    <!-- Loading -->
    @if (loading) {
    <div class="flex justify-center items-center py-12">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
      <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando datos...</span>
    </div>
    }

    <!-- Error -->
    @if (error) {
    <div class="mb-4 p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
      <div class="flex items-center gap-3">
        <svg class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <p class="text-error-600 dark:text-error-400">{{ error }}</p>
      </div>
    </div>
    }

    <!-- Duplicate Name Error -->
    @if (duplicateNameError) {
    <div class="mb-4 p-4 bg-warning-50 border border-warning-200 rounded-lg dark:bg-warning-500/10 dark:border-warning-500/20">
      <div class="flex items-center gap-3">
        <svg class="w-5 h-5 text-warning-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
        </svg>
        <p class="text-warning-600 dark:text-warning-400">{{ duplicateNameError }}</p>
      </div>
    </div>
    }

    <!-- Formulario -->
    @if (!loading) {
    <form (ngSubmit)="guardar()" #reasonForm="ngForm" class="space-y-5">

      <!-- Nombre -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Nombre <span class="text-error-500">*</span>
        </label>
        <input
          type="text"
          name="name"
          [(ngModel)]="name"
          (ngModelChange)="onNameChange($event)"
          required
          maxlength="30"
          placeholder="Nombre de la razón de descalificación"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          [class.border-warning-500]="nameValidationError"
        />
        @if (nameValidationError) {
        <p class="mt-1.5 text-sm text-warning-600 dark:text-warning-400 flex items-center gap-1">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
          </svg>
          {{ nameValidationError }}
        </p>
        } @else {
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">{{ name.length }}/30 caracteres</p>
        }
      </div>

      <!-- Descripción -->
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Descripción
        </label>
        <textarea
          name="description"
          [(ngModel)]="description"
          (ngModelChange)="onDescriptionChange($event)"
          rows="3"
          placeholder="Descripción de la razón (opcional)"
          class="dark:bg-dark-900 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          [class.border-warning-500]="descriptionValidationError"
        ></textarea>
        @if (descriptionValidationError) {
        <p class="mt-1.5 text-sm text-warning-600 dark:text-warning-400 flex items-center gap-1">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
          </svg>
          {{ descriptionValidationError }}
        </p>
        }
      </div>

      <!-- Auto Reagendar -->
      <div class="flex items-start gap-3">
        <input
          type="checkbox"
          name="autoReschedule"
          [(ngModel)]="autoReschedule"
          id="autoReschedule"
          class="mt-0.5 h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500/10 dark:border-gray-600 dark:bg-gray-800"
        />
        <div>
          <label for="autoReschedule" class="text-sm font-medium text-gray-700 dark:text-gray-300">
            Auto reagendar seguimiento
          </label>
          <p class="text-xs text-gray-500 dark:text-gray-400">
            Si está marcado, el sistema reagendará automáticamente el seguimiento al descalificar
          </p>
        </div>
      </div>

      <!-- Días de Reintento -->
      @if (autoReschedule) {
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Días de Reintento por Defecto
        </label>
        <input
          type="number"
          name="defaultRetryDays"
          [(ngModel)]="defaultRetryDays"
          min="1"
          step="1"
          placeholder="Ej: 30"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
        />
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Número de días antes de volver a intentar contactar</p>
      </div>
      }

      <!-- Estado -->
      <div class="flex items-start gap-3">
        <input
          type="checkbox"
          name="isActive"
          [(ngModel)]="isActive"
          id="isActive"
          class="mt-0.5 h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500/10 dark:border-gray-600 dark:bg-gray-800"
        />
        <div>
          <label for="isActive" class="text-sm font-medium text-gray-700 dark:text-gray-300">
            Razón activa
          </label>
          <p class="text-xs text-gray-500 dark:text-gray-400">
            Si está desmarcada, la razón no estará disponible al descalificar
          </p>
        </div>
      </div>

      <!-- Botones -->
      <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <app-button
          variant="outline"
          type="button"
          (btnClick)="cancelar()">
          Cancelar
        </app-button>
        <app-button
          variant="primary"
          type="submit"
          [disabled]="saving">
          {{ saving ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear Razón') }}
        </app-button>
      </div>
    </form>
    }
  </app-component-card>
</div>
